import styled from "@emotion/styled";
import { Theme, useTheme } from "@yuno/design-system-web";
import { useContext } from "react";
import { ThemeContext } from "../../../../context/theme-context";
import { CustomTheme } from "../../../../types/custom-theme";
import { Logo } from "./logo";
import { ShoppingCart } from "./shooping-cart";

const BLACK_THEME = "#000000";
const Mask = styled.div<{ theme?: Theme; isDark: boolean }>`
  background: ${({ theme, isDark }) =>
    isDark ? theme.palette.neutral.black : theme.palette.neutral.white[0]};
  height: 100%;
  z-index: 1000;
  opacity: 0.8;
  position: absolute;
  width: 423px;
`;

const Panel = styled.div(
  ({ theme, customTheme }: { theme?: Theme; customTheme: CustomTheme }) => ({
    width: "425px",
    height: "100%",
    position: "relative",
    transform: "scale(0.65)",
    top: "-100px",
    left: "-29px",
    "& p": {
      color: customTheme.shopping_cart.font_color,
    },
  })
);

export const LeftPanel = () => {
  const { customTheme } = useContext<{ customTheme: CustomTheme }>(
    ThemeContext
  );
  return (
    <>
      <Mask
        isDark={customTheme.shopping_cart.background_color === BLACK_THEME}
      />
      <Panel customTheme={customTheme}>
        <Logo />
        <ShoppingCart />
      </Panel>
    </>
  );
};
